import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

import TableHeader from './components/TableHeader';

import styles from './style.module.scss';

const TabTable = (props) => {
    const { callBack, listItem, list, showHeader, renderTabs, defaultFilters, className, title, ...restProps } = props;
    const [filters, setFilters] = useState({});

    console.log('filters', filters);

    useEffect(() => {
        if (defaultFilters) {
            setFilters({ ...defaultFilters });
        }
    }, []);

    useEffect(() => {
        if (callBack && filters.changeEvent) {
            callBack(filters);
        }
    }, [filters]);

    const generateList = useCallback(
        () => {
            if (typeof list === 'function') {
                return list({ filters });
            }
            return list;
        },
        [list],
    );

    const handleFilterChange = (name, val) => {
        setFilters({
            ...filters,
            [name]: val,
            changeEvent: true,
        });
    };

    const handleViewAllClick = () => {
        const { gender, level } = filters;
        props.handleViewAllClick({ gender, level });
    };

    return (
        <div className={`container ${className}`}>
            {showHeader && <TableHeader title={title} handleViewAllClick={handleViewAllClick} />}
            <div className={styles.tabs}>
                {renderTabs({
                    filters,
                    handleFilterChange,
                })}
            </div>
            <div className={styles.list}>
                {generateList()?.map(item => listItem({ item, filters, ...restProps }))}
            </div>
        </div>
    );
};

TabTable.propTypes = {
    showHeader: PropTypes.bool,
    renderTabs: PropTypes.func.isRequired,
    listItem: PropTypes.func.isRequired,
    list: PropTypes.oneOfType([PropTypes.func, PropTypes.instanceOf(Array)]),
    callBack: PropTypes.func,
    defaultFilters: PropTypes.instanceOf(Object),
};

TabTable.defaultProps = {
    showHeader: true,
    list: () => [],
    callBack: () => ({}),
    defaultFilters: null,
};

export default TabTable;
